import React, { ChangeEvent, RefObject, useRef } from "react";
import {
  OtpFormContainer,
  OtpInputContainer,
  OtpInput,
  ResendCodeText,
} from "../../pages/Otp/otp.styles";
import { styled } from "styled-components";

interface OtpInputFieldProps {
  otpValues: string[];
  handleOtpChange: (index: number, value: string) => void;
  handleKeyDown: (
    index: number,
    e: React.KeyboardEvent<HTMLInputElement>
  ) => void;
  handleResendCode: () => void;
  otpInputs: React.RefObject<HTMLInputElement>[] | null[] | undefined[];
}

const OtpInputField: React.FC<OtpInputFieldProps> = ({
  otpValues,
  handleOtpChange,
  handleKeyDown,
  handleResendCode,
  otpInputs,
}) => {
  // const otpInputs = useRef<HTMLInputElement[]>([]);
  // const otpInputs = Array.from({ length: 6 }, () =>
  //   useRef<HTMLInputElement>(null)
  // );
  return (
    <>
      <OtpFormContainer>
        <OtpInputContainer className="otpInput">
          <InputStyle>
            {otpInputs.map((ref, index) => (
              <OtpInput
                key={index}
                value={otpValues[index]}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handleOtpChange(index, e.target.value)
                }
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
                  handleKeyDown(index, e)
                }
                type="text"
                maxLength={1}
                ref={ref}
              />
            ))}
          </InputStyle>
        </OtpInputContainer>
      </OtpFormContainer>

      <ResendCodeContainer>
        <ResendCodeText onClick={handleResendCode}>Resend code</ResendCodeText>
      </ResendCodeContainer>
    </>
  );
};

export default OtpInputField;

export const InputStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  gap: 1.5rem;
`;

export const ResendCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 25px;
  margin-bottom: 5rem;
`;
